import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index.js'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
   //路由懒加载，优化性能
   // {
   //   path:"*",
   //   redirect:'/norights'
   // },
   {
   	 path: '/',
     redirect:'/home',//默认显示首页的二级路由
     component:() => import('@/view/Index'),
     children:
     [
   	 { path:'/home',
       name:'home',
   	   component:() => import('@/view/Home/home'),
       meta: {
             keepAlive: false 
           }
   	 },
		 //products
	{ path:'/homecate/:id',
	  name:'homecate',
	  component:() => import('@/view/Home/homeCate'),
	  meta: {
	        keepAlive: true // 需要被缓存
	      }
	},
	{ path:'/homecateall/:id',
	  name:'homecateall',
	  component:() => import('@/view/Home/homeCateAll'),
	  meta: {
	        keepAlive: true // 需要被缓存
	      }
	},
	{ path:'/homedetail/:id',
	  name:'homedetail',
	  component:() => import('@/view/Home/homeDetail'),
	  meta: {
	        keepAlive: false 
	      }
	},	 
	//东华大学合作创作中心
		 { path:'/trends',
		   name:'trends',
		   component:() => import('@/view/Home/trends.vue'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
		 
		 
		 
		 
	 // about us
     { path:'/introduction',
		   name:'introduction',
       component:() => import('@/view/Us/introduction')
     },
	 { path:'/history',
	   component:() => import('@/view/Us/history')
	 }, 
	 { path:'/honors',
	   component:() => import('@/view/Us/honors')
	 }, 	 
	 //industrial distribution	 
	{ path:'/cotton',
	name:'cotton',
	  component:() => import('@/view/IndustrialDistribution/CottonSocks')
	},
	{ path:'/seamless',
	  component:() => import('@/view/IndustrialDistribution/Seamless')
	}, 
	{ path:'/design',
	 name:'design',
	  component:() => import('@/view/IndustrialDistribution/Desgin')
	}, 	 
	{ path:'/chain',
	 name:'chain',
	  component:() => import('@/view/IndustrialDistribution/industryChain')
	},	 
	//partners	,这个页面路由得缓存js，不然卡死	 
	{ path:'/partners',
	name:'partners',
	  component:() => import('@/view/Partners/partners'),
		meta: {
		      keepAlive: true // 需要被缓存
		    }
	},		 
	//givingback
	{ path:'/givingback',
	name:'givingback',
	  component:() => import('@/view/GivingBack/givingback')
	},		 
    //contact us
    { path:'/contact',
      name:'contact',
      component:() => import('@/view/Contact'),
      meta: {
            keepAlive: false // 需要被缓存
          }
    },
   
   
     { path:'/userAllInfo',
       component:() => import('@/view/UserInfo/userAllInfo')
     },
     { path:'/userInfo',
       component:() => import('@/view/UserInfo/userInfo')
     },
     { path:'/userAvatar',
       component:() => import('@/view/UserInfo/userAvatar')
     },
     { path:'/userPwd',
       component:() => import('@/view/UserInfo/userPwd')
     },
   
     // { path:'/detail/:id',
     //   name:'detail',
     //   component:() => import('@/view/Community/detail'),
     //   meta: {
     //         keepAlive: false // 需要被缓存
     //       }
     // },
     
    
  
     
     ]
   },
    { path: '/login', component:() => import('@/view/Login')},
   // { path: '/register', component:() => import('@/view/Register')},
   { path:'/norights',component:() => import('@/view/Norights')},
   { path:'/freeze',component:() => import('@/view/Freeze')},
  ]
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转
 store.dispatch('getUserInfoActions')
	let status_user =store.getters.statesw
  //console.log(status_user)
  if (to.path === '/login' || to.path === '/freeze'  || to.path === '/norights' ) return next()
  // 获取token
    if (status_user ==2) {
		return next('/freeze')
	 }
  // const tokenStr = window.sessionStorage.getItem('token')
  //  if (!tokenStr) return next('/login')
  next()
})


//每次路由跳转，返回页面最顶部
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0)

 
})
export default router
